import { render, staticRenderFns } from "./VoteStatus.vue?vue&type=template&id=80f237ce&"
import script from "./VoteStatus.vue?vue&type=script&lang=js&"
export * from "./VoteStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports